<template>
  <div class="jsfw">
    <div class="banner">
      <div class="img">
        <img src="../../assets/myyq3.jpg" />
        <!-- <img :src="this.$store.getters.banner[this.$route.path]" /> -->
      </div>
      <div class="menu">
        <van-tabs v-model="active">
          <template v-for="item in list">
            <van-tab :title="item.category.label" :key="item.id">
              <div class="content" v-html="item.content">
                <!-- <div class="img">
                  <img src="../../assets/s1.png" />
                </div>
                <div class="contentDiv">
                  <div class="contentTxt">
                      <p class="ptxt" style="text-align: left;">
                        为了更好的服务客户，使墓前四季鲜花烂漫，生机盎然，我园推出全新的祭扫方式——盆花摆租业务
                      </p>
                      <p
                        class="ptxt"
                        _msthash="822419"
                        _msttexthash="215828873"
                        style="text-align: left;"
                      >
                        盆花：三色堇、四季海棠、太阳花、雏菊、矮牵牛、羽衣甘蓝等……
                      </p>
                      <div class="imglist">
                        <img src="../../assets/h1.png" />
                        <img src="../../assets/h2.png" />
                        <img src="../../assets/h3.png" />
                        <img src="../../assets/h4.png" />
                        <img src="../../assets/h5.png" />
                        <img src="../../assets/h6.png" />
                      </div>
                      <p
                        class="ptxt"
                        _msthash="822653"
                        _msttexthash="64987819"
                        style="text-align: left;"
                      >
                        盆景：铁树、火棘、南天竹等……
                      </p>
                      <div class="imglist">
                        <img src="../../assets/h11.png" />
                        <img src="../../assets/h12.png" />
                        <img src="../../assets/h13.png" />
                        <img src="../../assets/h14.png" />
                        <img src="../../assets/h15.png" />
                        <img src="../../assets/h16.png" />
                      </div>
                    </div>
                    {{ content }}
                  </div>
                </div> -->
              </div>
            </van-tab>
          </template>
          <!-- <van-tab title="鲜花装饰">
            <div class="content">
              <div class="img">
                <img src="../../assets/s2.png" />
              </div>
              <div class="contentDiv">
                <div class="contentTxt">
                  <div>
                    <p class="ptxt" style="text-align: left;">
                      为了更好的服务客户，我们提供多种鲜花供您选择，更有专业花艺设计师为您进行插花设计及现场布置。
                    </p>
                    <p class="ptxt" style="text-align: left;">
                      鲜花品种：百合、玫瑰、洋兰、菊花、康乃馨等……
                    </p>
                    <div class="imglist1">
                      <img src="../../assets/xh.png" />
                    </div>
                  </div>

                  <div class="xhlist">
                    <div>
                      <p class="txt">
                        服务流程
                      </p>
                      <div>
                        <div class="xh">
                          <img src="../../assets/n1.png" />
                          <div class="item"><p>咨询接待</p></div>
                        </div>
                        <div class="xh">
                          <img src="../../assets/n2.png" />
                          <div class="item">
                            <p>
                              选择鲜花
                            </p>
                          </div>
                        </div>
                        <div class="xh">
                          <img src="../../assets/n3.png" />
                          <div class="item">
                            <p>
                              装饰设计
                            </p>
                          </div>
                        </div>
                        <div class="xh">
                          <img src="../../assets/n4.png" />
                          <div class="item">
                            <p>
                              付清款项
                            </p>
                          </div>
                        </div>
                        <div class="xh">
                          <img src="../../assets/n5.png" />
                          <div class="item">
                            <p>
                              现场制作
                            </p>
                          </div>
                        </div>
                        <div class="xh">
                          <img src="../../assets/n6.png" />
                          <div class="item">
                            <p>
                              客户验收
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {{ content }}
                </div>
              </div>
            </div>
          </van-tab>
          <van-tab title="墓石改建">
            <div class="content">
              <div class="img">
                <img src="../../assets/s3.png" />
              </div>
              <div class="contentDiv">
                <div class="contentTxt">
                  <div>
                    <div>
                      <div class="beidiv">
                        <p class="beititle">
                          旧碑缺点
                        </p>
                        <div class="beicon">
                          <p>
                            <i class="iconfont" style="color:#ff0000;">&#xed1a;</i>
                            石材表面会出现锈斑、水斑、颜色泛黄等难以清理的问题；
                          </p>
                          <p>
                            <i class="iconfont" style="color:#ff0000;">&#xed1a;</i>
                            碑文排版不工整不规范
                          </p>
                        </div>
                      </div>
                      <div class="beidiv">
                        <p class="beititle">
                          新碑优点
                        </p>
                        <div class="beicon">
                          <p>
                            <i class="iconfont" style="color:#dea767;">&#xed1b;</i>
                            新石材坚硬耐风化，容易清理；
                          </p>
                          <p>
                            <i class="iconfont" style="color:#dea767;">&#xed1b;</i>
                            碑文刻字采用了机器喷刻；
                          </p>
                          <p style="text-align: left;">
                            <i class="iconfont" style="color:#dea767;">&#xed1b;</i>
                            解决了石棺空间窄小的问题；
                          </p>
                          <p style="text-align: left;">
                            <i class="iconfont" style="color:#dea767;">&#xed1b;</i>
                            采用双层盖板密封方式，密封效果有了进一步的提升
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="xhlist">
                    <div>
                      <p class="txt">
                        服务流程
                      </p>
                      <div>
                        <div class="xh">
                          <img src="../../assets/n1.png" />
                          <div class="item"><p>咨询接待</p></div>
                        </div>
                        <div class="xh">
                          <img src="../../assets/n2.png" />
                          <div class="item">
                            <p>
                              凭《墓穴证书》及逝者照片办理改建业务
                            </p>
                          </div>
                        </div>
                        <div class="xh">
                          <img src="../../assets/n3.png" />
                          <div class="item">
                            <p>
                              当天付清改建款
                            </p>
                          </div>
                        </div>
                        <div class="xh">
                          <img src="../../assets/n6.png" />
                          <div class="item">
                            <p>
                              整墓改建及换碑客户办理碑文、瓷像制作
                            </p>
                          </div>
                        </div>
                        <div class="xh">
                          <img src="../../assets/n4.png" />
                          <div class="item">
                            <p>
                              改建加工30个工作日，整墓改建45个工作日
                            </p>
                          </div>
                        </div>
                        <div class="xh">
                          <img src="../../assets/n5.png" />
                          <div class="item">
                            <p>
                              接到工作人员通知后验收
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {{ content }}
                </div>
              </div>
            </div>
          </van-tab>
          <van-tab title="祭扫用品">
            <div class="content">
              <div class="img">
                <img src="../../assets/s4.png" />
              </div>
              <div class="contentDiv">
                <div class="contentTxt">
                  <div>
                    <p class="saocon">
                      祖宗虽远，祭祀不可不诚，在《诗经》的祭祀诗中，人们怀着虔诚的心情，把酒醴、牛羊、植物等祭品奉献给神灵和先祖，期盼着他们降下福禄。
                    </p>
                    <p class="saocon">
                      遥祭先人，精心准备丰富的物品在祭拜之时恭敬奉上，既是祭祀过程中重要的一个环节，也是国人传统文化的一部分，是人们重要的精神依托。
                    </p>
                    <img
                      src="../../assets/xl.png"
                      alt=""
                      style="    width: 100%;
    margin: .53333rem auto;"
                    />
                    <p class="saocon">
                      随着现代文明进步，祭祀之时我们更偏重精神上的自我表达。
                      不同以往的锡箔、黄纸，现代社会时尚精致的祭祀用品、鲜花花束已成为人们对先祖祈祷和祝愿的更好媒介，传递着孝心与恭敬心，体现了祭祀文化的文明风尚。
                    </p>
                    <p class="saocon" style="text-align: left;">
                      嘉盛陵园为您提供整套的祭祀用品，可提前预约现场取货！
                    </p>
                    <img
                      src="../../assets/taiyang.png"
                      alt=""
                      style="width: 100%;margin: .53333rem auto;"
                    />
                  </div>
                  {{ content }}
                </div>
              </div>
            </div>
          </van-tab>
          <van-tab title="其他服务">
            <div class="content">
              <div class="img">
                <img src="../../assets/s5.png" />
              </div>
              <div class="contentDiv">
                <div class="contentTxt">{{ content }}</div>
              </div>
            </div>
          </van-tab> -->
        </van-tabs>
        <div>
          <div class="bottomDiv bottomDivContent">
            <a href="tel:0546-75889977">24小时咨询热线 ｜ 0546-75889977</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bus from '../../common/bus'
export default {
  name: 'jiashengfuwu',
  components: {},
  data() {
    return {
      count: 0,
      active: 0,
      isLoading: false,
      content: '',
      code: 'FWPHZB',
      list: [],
    }
  },
  created() {
    this.active = this.$route.params.type
    if (this.active == 0) {
      this.code = 'FWPHZB'
      bus.$emit('path', 'phzb')
    } else if (this.active == 1) {
      this.code = 'FWXHZS'
      bus.$emit('path', 'xhzs')
    } else if (this.active == 2) {
      this.code = 'FWMSGJ'
      bus.$emit('path', 'msgj')
    } else if (this.active == 3) {
      this.code = 'FWJSYP'
      bus.$emit('path', 'jsyp')
    } else if (this.active == 4) {
      bus.$emit('path', 'qtfw')
      this.code = 'FWQTFW'
    }
    this.getData()
  },
  methods: {
    getData() {
      var that = this
      this.$queryPage('OweService', {}, function(res) {
        that.list = res.data
      })
    },
  },
  watch: {
    $route() {
      if (this.active != this.$route.params.type) {
        this.active = this.$route.params.type
      }
    },
    active() {
      if (this.active == 0) {
        bus.$emit('path', 'phzb')
        this.code = 'FWPHZB'
      } else if (this.active == 1) {
        bus.$emit('path', 'xhzs')
        this.code = 'FWXHZS'
      } else if (this.active == 2) {
        bus.$emit('path', 'msgj')
        this.code = 'FWMSGJ'
      } else if (this.active == 3) {
        bus.$emit('path', 'jsyp')
        this.code = 'FWJSYP'
      } else if (this.active == 4) {
        bus.$emit('path', 'qtfw')
        this.code = 'FWQTFW'
      }
      this.getData()
    },
  },
}
</script>

<style>
.jsfw .bottomDivContent {
  height: 1.6rem;
  background: #fff;
  box-shadow: 0 -0.027rem 0.05333rem 0 hsl(0deg 0% 89% / 50%);
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  padding: 0.21333rem 0.4rem;
}
.jsfw .bottomDiv a {
  display: block;
  width: 9.2rem;
  height: 1.17333rem;
  background: url(data:image/png;base64,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)
    #dea767 no-repeat left 1.33rem center/.32rem 0.37333rem;
  border-radius: 0.58667rem;
  font-size: 0.37333rem;
  font-weight: 500;
  color: #333;
  line-height: 1.17333rem;
  text-align: center;
  padding-left: 0.27rem;
}

.jsfw .beicon {
  padding: 0.53rem;
  font-size: 0.37333rem;
  color: #666;
  line-height: 0.75rem;
}
.jsfw .saocon {
  padding: 0.53rem;
  font-size: 0.37333rem;
  color: #666;
  line-height: 0.75rem;
}
.jsfw .beidiv {
  width: 9.2rem;
  background: #fff;
  box-shadow: 0 0.05333rem 0.53rem 0 hsl(0deg 1% 61% / 26%);
  border-radius: 0.05333rem;
  border: 0.027rem solid #f8f8f8;
  overflow: hidden;
  margin-bottom: 0.4rem;
  margin-top: 0.4rem;
}

.jsfw .beititle {
  width: 100%;
  height: 1.06667rem;
  background: #dea7675e;
  font-size: 0.42667rem;
  font-weight: 600;
  color: #333;
  line-height: 1.06667rem;
  letter-spacing: 0.05333rem;
  text-align: center;
}
.jsfw .xhlist {
  padding: 0.67rem 0.4rem;
  height: 13.6rem;
  background: url(../../assets/sqqy21.png) no-repeat 50%/100% 100%;
}
.jsfw .xhlist .txt {
  font-size: 0.53rem;
  font-weight: 500;
  color: #dea767;
  line-height: 0.75rem;

  margin-bottom: 1.06667rem;
}
.jsfw .xh {
  position: relative;
  margin-bottom: 1.44rem;

  display: flex;
}
.jsfw .xh img {
  width: 0.64rem;
  height: 0.53rem;
  margin-right: 0.48rem;
}
.jsfw .ptxt {
  margin-top: 0.5rem;
  font-size: 0.37333rem;
  color: #666;
  line-height: 0.7rem;
  margin-bottom: 0.27rem;
}
.jsfw .imglist {
  margin-bottom: 0.53rem;
  display: flex;
  flex-wrap: wrap;
  margin-left: 0.2rem;
}
.jfw .xh .item {
  font-size: 0.37333rem;
  color: #333;
  line-height: 0.53rem;
  font-weight: 500;
}
.jsfw .imglist img {
  width: 2.8rem;
  height: 2.93rem;
  margin-right: 0.18667rem;
  margin-bottom: 0.18667rem;
  border-radius: 0.05333rem;

  /* display: flex; */
}
.jsfw .imglist1 img {
  width: 9.2rem;
  height: 10.88rem;
  border-radius: 0.05333rem;
}
.jsfw .contentDiv {
  /* margin: 0.5rem; */
  color: #666;
  line-height: 0.7rem;
}
.jsfw .contentDiv .img {
  /* margin: 0.5rem; */
}
.jsfw .banner .img {
  margin-top: 0.3rem;
}
.jsfw .banner .img img {
  object-fit: cover;

  display: block;
  width: 100%;
  height: 100%;
}
.jsfw .banner .menu {
}
.jsfw .van-tabs__wrap .van-tabs__nav .van-tab {
  font-size: 0.37333rem;
  color: #333;
}
.jsfw .van-tabs__wrap .van-tabs__nav .van-tab--active {
  color: #dea767;
  font-weight: 400;
}
.jsfw .van-tabs__line {
  background-color: #dea767;
}
.jsfw .van-tabs__content {
  padding: 0 0.4rem;
}
.jsfw .list {
  padding: 0.67rem 0 0.27rem;
  border-bottom: 0.027rem solid #dfdfdf;
}
.jsfw .menu .list .img {
  width: 100%;
  height: 3rem;
}
.jsfw .menu .list .img img {
  width: 100%;
  border-radius: 5px;
}
.jsfw .menu .list .title {
  font-size: 0.42667rem;

  color: #333;
  line-height: 0.61333rem;
  margin-bottom: 0.13333rem;
  margin-top: 0.1rem;
}
.jsfw .menu .list .time {
  font-size: 0.37333rem;
  color: #666;
  line-height: 0.53rem;
}
</style>
